import "tiny-slider/dist/tiny-slider.css";
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider";

let slidersCenterOff = document.querySelectorAll(".carousel-image__right");

Array.prototype.slice
  .call(slidersCenterOff)
  .forEach(function (slider_center_off_right) {
    let carouselTitle = slider_center_off_right.dataset.label
      ? slider_center_off_right.dataset.label + " carousel navigation"
      : null;
    const elementTitle =
      slider_center_off_right.parentNode.parentNode.parentNode;
    if (elementTitle && carouselTitle === null) {
      const header = elementTitle.getElementsByTagName("h2");
      if (header && header.length > 0) {
        const carouselTitleElement = header[0];
        if (carouselTitleElement && carouselTitleElement.innerText !== "") {
          carouselTitle = carouselTitleElement.innerText;
        }
      }
    }

    const element =
      slider_center_off_right.parentNode.parentNode.parentNode.querySelector(
        ".controls"
      );
    if (carouselTitle && element) {
      setTimeout(() => {
        element.setAttribute("aria-label", carouselTitle);
      }, 1000);
    }
    const slider = tns({
      container: slider_center_off_right,
      items: 1.12,
      autoplay: false,
      autoplayButtonOutput: false,
      controlsPosition: "top",
      mouseDrag: false,
      nav: false,
      arrowKeys: false,
      gutter: 20,
      controlsContainer: element,
      touch: false,
      loop: false,
      responsive: {
        568: {
          items: 1.25,
        },
        768: {
          items: 1.75,
        },
        1350: {
          items: 1.85,
        },
        1600: {
          items: 2,
        },
        1700: {
          items: 2.25,
        },
        1900: {
          items: 2.5,
        },
      },
      onInit: function (slider_center_off_right) {
        const sliderContainer =
          slider_center_off_right.container.parentNode.parentNode.parentNode
            .childNodes;
        if (sliderContainer && sliderContainer.length) {
          sliderContainer.forEach((element) => {
            element.removeAttribute("aria-live");
            element.removeAttribute("aria-atomic");
          });
        }

        slider_center_off_right.controlsContainer.setAttribute("tabindex", -1);
        slider_center_off_right.nextButton.setAttribute("tabindex", 0);
        slider_center_off_right.prevButton.setAttribute("tabindex", 0);
      },
    });
  });

let sliderBox = document.querySelectorAll(".slider-boxes__slider");

Array.prototype.slice.call(sliderBox).forEach(function (sliderBoxInside) {
  let carouselTitle = sliderBoxInside.dataset.label
    ? sliderBoxInside.dataset.label + " carousel navigation"
    : null;
  const elementTitle = sliderBoxInside.parentNode.parentNode.parentNode;
  if (elementTitle && carouselTitle === null) {
    const header = elementTitle.getElementsByTagName("h2");
    if (header && header.length > 0) {
      const carouselTitleElement = header[0];
      if (carouselTitleElement && carouselTitleElement.innerText !== "") {
        carouselTitle = carouselTitleElement.innerText;
      }
    }
  }

  const element =
    sliderBoxInside.parentNode.parentNode.parentNode.querySelector(".controls");
  if (carouselTitle && element) {
    setTimeout(() => {
      element.setAttribute("aria-label", carouselTitle);
    }, 1000);
  }
  const slider = tns({
    container: sliderBoxInside,
    items: 1,
    autoplay: false,
    autoplayButtonOutput: false,
    controlsPosition: "bottom",
    mouseDrag: false,
    nav: false,
    arrowKeys: false,
    gutter: 0,
    controlsContainer: element,
    touch: false,
    loop: false,
    onInit: function (sliderBoxInside) {
      const sliderContainer =
        sliderBoxInside.container.parentNode.parentNode.parentNode.childNodes;
      if (sliderContainer && sliderContainer.length) {
        sliderContainer.forEach((element) => {
          element.removeAttribute("aria-live");
          element.removeAttribute("aria-atomic");
        });
      }

      sliderBoxInside.controlsContainer.setAttribute("tabindex", -1);
      sliderBoxInside.nextButton.setAttribute("tabindex", 0);
      sliderBoxInside.prevButton.setAttribute("tabindex", 0);
    },
  });
});
